import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { BudgetActions } from 'pages/Catalogue/components/Budget/components/BudgetActions';
import { BudgetStatus } from 'pages/Catalogue/components/Budget/components/BudgetStatus';

dayjs.extend(customParseFormat);

// useBudget.ts already normalizes the backend's raw 'DD/MM/YYYY HH:mm:ss'
// dates to 'YYYY-MM-DD' before this table ever sees them, so that's the
// format to parse here — not the backend's raw wire format.
const NORMALIZED_DATE_FORMAT = 'YYYY-MM-DD';

export const useColumns = (refetchBudgets: () => void) =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Budgets',
        columns: [
          {
            Header: 'Season',
            accessor: 'season',
          },
          {
            Header: 'Start Date',
            accessor: 'startDate',
            Cell: ({ value }) => (
              <span>
                {value ? dayjs(value, NORMALIZED_DATE_FORMAT).format('MM/DD/YYYY') : ''}
              </span>
            ),
          },
          {
            Header: 'End Date',
            accessor: 'endDate',
            Cell: ({ value }) => (
              <span>
                {value ? dayjs(value, NORMALIZED_DATE_FORMAT).format('MM/DD/YYYY') : ''}
              </span>
            ),
          },
          {
            Header: 'Number',
            accessor: 'num',
          },
          {
            Header: 'Name',
            accessor: 'name',
          },
          {
            Header: 'Status',
            accessor: 'budgetStatus',
            disableSortBy: true,
            Cell: ({ row }) => <BudgetStatus status={row.original.budgetStatus} />,
          },
          {
            accessor: 'action',
            disableSortBy: true,
            Cell: ({ row }) => <BudgetActions row={row.original} onChanged={refetchBudgets} />,
          },
        ],
      },
    ],
    [refetchBudgets]
  );
